import Dialog from './src/';

const LOADING = {

  install (Vue) {
    Vue.prototype.$loading = (options) => {
      Dialog.open(options);
    }

    Vue.prototype.$loadingFinish = (options) => {
      Dialog.close(options);
    }
  }

}

export default LOADING;

